<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		</div>
		<div class="mb-2 mt-2 pt-3">
			<button-search :isphone="layout.is_phone" ref="buttonSearch" placeholder="搜尋 標題" @search="searchEvent" :showGj="true">
				<!-- 左边 -->
				<template #left>
					<!-- <el-button type="danger" v-auth="'del'+auth_val" @click="deleteAll" size="mini">批量刪除</el-button> -->
				</template>

				<!-- 高級搜索 1-->
				<template #from>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item label="標題" class="mb-0">
							<el-input size="small" v-model="from.title" placeholder="搜尋標題"></el-input>
						</el-form-item>
						
						<el-form-item label="做題時間" size="small" class="mb-0">
							<el-date-picker v-model="from.time" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd"
							 range-separator="至" start-placeholder="開始日期" end-placeholder="結束日期" :picker-options="pickerOptions">
							</el-date-picker>
						</el-form-item>

						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">搜尋 </el-button>
							<el-button size="small" @click="clearSearch">清空篩選條件</el-button>
						</el-form-item>

					</el-form>
				</template>
			</button-search>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2">
			<el-table :data="tableData" @sort-change="sortChange" border style="width: 100%" @selection-change="handleSelectionChange">

				<el-table-column align="center" width="120" prop="topic_no" label="編號">
				</el-table-column>
					
				<el-table-column align="center" prop="user_name" label="使用者名稱">
				</el-table-column>
				
				<el-table-column align="center" prop="grade_name" label="年級">
				</el-table-column>
				
				<el-table-column align="center" prop="subject_name" label="學科">
				</el-table-column>
				
				<el-table-column align="center" prop="total" label="題數">
				</el-table-column>
				<el-table-column align="center" prop="yes_num" label="答對數量">
				</el-table-column>
				<el-table-column align="center" prop="score" label="得分">
				</el-table-column>
				
				<el-table-column align="center" label="限時/用時">
                    <template slot-scope="scope">   {{scope.row.time}} / {{scope.row.use_time}}</template>
				</el-table-column>

				<el-table-column align="center" width="80"  label="題目">
					<template slot-scope="scope" >
						<div slot="reference" style="cursor: pointer;" class="name-wrapper">
							<el-tag size="medium" :class="{ 'is-disabled': scope.row.status === 0 }"  @click="scope.row.status !== 0 ? openModel(scope.row.id) : null"  >查看</el-tag>
						  </div>
					  </template>
				</el-table-column>
<!-- 
				<el-table-column align="center" width="80"  label="題目組成">
					<template slot-scope="scope">
						<div slot="reference" style="cursor: pointer;" class="name-wrapper">
							<el-tag size="medium" :class="{ 'is-disabled': scope.row.status === 0 }"  @click="scope.row.status !== 0 ? openModelInfo(scope.row.id) : null"  >查看</el-tag>
						  </div>
					  </template>
				</el-table-column> -->
				
				<el-table-column align="center"  prop="status"  label="完成度">
					<template slot-scope="v">
						<span style="color: red;" v-if="v.row.status==0">未完成</span>
						<span class="text-success" v-if="v.row.status==1">已完成</span>
						<span class="text-warning" v-if="v.row.status==2">超時結束</span>
					</template>
				</el-table-column>
				
				<el-table-column align="center" prop="create_time" width="200" label="開始時間">
				</el-table-column>
				
				<el-table-column align="center" prop="update_time" width="200" label="結束時間">
				</el-table-column>
			</el-table>
		</div>


		<div style="height: 60px;"></div>
		<el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed all_foot_page" >
			<!-- 底部 -->

			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
				 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
				</el-pagination>
			</div>
		</el-footer>

		<el-dialog :close-on-click-modal="false"  title="組成結構" :visible.sync="createModelInfo" top="5vh" :width="layout.is_phone?'90%':'80%'">
            <template>
                <el-table :data="dialog_label_list" show-summary max-height="550" border style="width: 100%"  >
					<el-table-column align="center" prop="name" label="類型">
					</el-table-column>
				
                    <el-table-column align="center"  prop="total" label="出現題數">
                    </el-table-column>

                    <el-table-column align="center"  prop="yes" label="答對題數">
                    </el-table-column>
                </el-table>
            </template>
			<template>
                <el-table :data="dialog_difficulty_list" show-summary max-height="550" border style="width: 100%;margin-top: 30px;"  >
					<el-table-column align="center" prop="name" label="難度">
					</el-table-column>
				
                    <el-table-column align="center"  prop="total" label="出現題數">
                    </el-table-column>

                    <el-table-column align="center"  prop="yes" label="答對題數">
                    </el-table-column>
                </el-table>
            </template>
		</el-dialog>

        <el-dialog :close-on-click-modal="false"  title="內容" :visible.sync="createModel" top="5vh" :width="layout.is_phone?'90%':'80%'">
            <template>
                <el-table :data="dialog_list"  max-height="550" border style="width: 100%"  :row-class-name="tableRowClassName">
					
					<el-table-column align="center" prop="topic_no" label="題目編號">
					</el-table-column>
					<el-table-column align="center" prop="title" label="題目">
						<template slot-scope="scope">
							<div v-if="scope.row.title.length > 20">
								{{ scope.row.title.substring(0, 20) }}... 
								<el-button type="text" @click="showFullTitle(scope.row.title)">點擊查看</el-button>
							</div>
							<div v-else>
								{{ scope.row.title }}
							</div>
						</template>
					</el-table-column>

					<el-table-column align="center"  prop="label_name"  label="標籤">
						<template slot-scope="v">
							<span>
								<el-tag type="warning">{{v.row.label_name}}</el-tag>
							</span>
						</template>
					</el-table-column>

					<el-table-column align="center" label="正確答案/提交答案">
						<template slot-scope="scope">   {{scope.row.answer_o}} / {{scope.row.option_sel ? scope.row.option_sel : '无'}}</template>
					</el-table-column>

                    <el-table-column align="center"  prop="score" label="分數">
                    </el-table-column>
					<el-table-column align="center"  prop="difficulty" label="難度">
                    </el-table-column>
                    <el-table-column align="center" prop="status" label="對/錯">
                        <template slot-scope="v">
                            <span  class="text-warning" v-if="v.row.status==0">未做</span>
                            <span class="text-success" v-if="v.row.status==1">對</span>
                            <span class="text-danger" v-if="v.row.status==2">錯</span>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
		</el-dialog>
	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				createModel: false,
				createModelInfo: false,
				editIndex: -1,
                type:3,
				//搜索數据
				from: {
					title: '',
					grade_id:'-1',
					subject_id:'-1',
					status:'-1',
					time: [],
				},
				model_title: 'UserTopic',
				auth_val: 'UserTopic',
				preUrl: "data/userTaskList", //列表地址
				delAllUrl: "data/delUserEmailAll", //批量删除地址
				delUrl: "data/delUserEmail", //删除單条地址
                editStatusUrl: "data/editStatusUserEmail", //修改狀態地址

				tableData: [],
				
				prop: 'id',
				sort: 'descending',
				rule_list: [],
				total_list: [],
				check_img_list: [],
				fileList: [],

				school_list: [],
				inst_list: [],
				user_list: [],
				
                dialog_list:[],
                dialog_difficulty_list:[],
                dialog_label_list:[],
			}
		},
		created() {
			this.commonList(['subject_list','grade_list']);
		},
		methods: {
			tableRowClassName({row, rowIndex}) {
				if (row.status === 0) {
				return 'warning-row';
				} else if (row.status === 1) {
				return 'success-row';
				}
				return 'danger-row';
			},
			handleClick(tab, event) {
				this.search = ''
				this.clearSearch()
				this.getList()
			},
			sortChange(column) {

				this.prop = column.prop
				this.sort = column.order
				this.getList()
			},
			 // 顯示完整題目内容
			showFullTitle(title) {
				this.fullTitle = title;
				this.dialogVisible = true;
			},
			//提交
			submit() {
				
				
				this.$refs.formEdit.validate(res => {
					if (res) {
					
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 關閉模态框
					}
				})
			},
			//公共列表
			commonList(type) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					this.grade_list = list.grade
					this.subject_list = list.subject

					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
		
		
			// 打开模态框
			openModel(e) {
                this.layout.loading = true;
				this.axios.post('/admin/data/getTopicList', {
					id: e,
				}, {
					token: true,
				}).then(res => {
					let all = res.data.data
                    this.dialog_list = all.list;

                    // // 打开dialog
                    this.createModel = true
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},

			// 打开模态框
			openModelInfo(e) {
                this.layout.loading = true;
				this.axios.post('/admin/data/getTopicInfo', {
					id: e,
				}, {
					token: true,
				}).then(res => {
					let all = res.data.data
                    this.dialog_difficulty_list = all.list.difficulty;
                    this.dialog_label_list = all.list.label;

                    // // 打开dialog
                    this.createModelInfo = true
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},


			//公共列表

			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.total_list = e.total_list
				this.check_img_list = e.list.map(item => {
					return item.head
				})
			},
			// 清空篩選條件
                clearSearch() {
				this.from = {
                    title: '',
					type:'-1',
					grade_id:'-1',
					subject_id:'-1',
					status:'-1',
					time: [],
				}

				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>


<style>
 .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }

  .el-table .danger-row {
    background: rgb(253, 226, 226)
  }

  .is-disabled {
	cursor: not-allowed;  /* 禁止光標样式 */
	color: #c0c4cc;       /* 灰色文字 */
	background-color: #f5f7fa; /* 灰色背景 */
  }
</style>
